module.exports = __webpack_public_path__ + "static/media/-_Document management.e860180b.png";